export default {
  init(instance) {
    document.addEventListener('alpine:init', () => {
      instance.data('letsConnectPartnerForm', () => {
        return {
          inputs: {
            full_name: '',
            company_name: '',
            email: '',
            phone: '',
            message: '',
          },
          errors: {},
          showMessage: false,
          successMessage: null,
          errorMessage: null,

          validateField(fieldName) {
            delete this.errors[fieldName];
            switch (fieldName) {
              case 'full_name':
                if (!this.inputs.full_name.trim()) {
                  this.errors.full_name =
                    'Please complete this required field.';
                } else if (!/^[A-Za-z0-9 ]+$/.test(this.inputs.full_name)) {
                  this.errors.full_name =
                    'Must only contain letters, numbers, and spaces.';
                } else if (this.inputs.full_name.length > 50) {
                  this.errors.full_name = 'Must be less than 50 characters.';
                }
                break;

              case 'phone':
                if (!this.inputs.phone) return;
                try {
                  const parsed = parseInt(this.inputs.phone);
                  if (isNaN(parsed)) {
                    this.errors.phone = 'Must be a number.';
                  }
                } catch (e) {
                  this.errors.phone = 'Must be a number.';
                }
                break;

              case 'email':
                if (!this.inputs.email.trim()) {
                  this.errors.email = 'Please complete this required field.';
                } else if (!this.validateEmail(this.inputs.email)) {
                  this.errors.email = 'Email must be formatted correctly.';
                }
                break;

              case 'message':
                if (!this.inputs.message.trim()) {
                  this.errors.message = 'Please complete this required field.';
                }
                break;

              case 'company_name':
                if (!this.inputs.company_name.trim()) {
                  this.errors.company_name =
                    'Please complete this required field.';
                } else if (!/^[A-Za-z0-9 ]+$/.test(this.inputs.company_name)) {
                  this.errors.company_name =
                    'Must only contain letters, numbers, and spaces.';
                } else if (this.inputs.company_name.length > 50) {
                  this.errors.company_name = 'Must be less than 50 characters.';
                }
                break;

              default:
                break;
            }
            console.log('Errors:', this.errors);
          },

          validateAll() {
            this.errors = {};

            Object.keys(this.inputs).forEach((fieldName) => {
              this.validateField(fieldName);
            });
          },

          validateEmail(email) {
            const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return re.test(email.toLowerCase());
          },

          async submitForm() {
            this.validateAll();
            if (Object.keys(this.errors).length > 0) {
              return;
            }

            const payload = {
              full_name: this.inputs.full_name,
              company_name: this.inputs.company_name,
              email: this.inputs.email,
              phone: this.inputs.phone,
              message: this.inputs.message,
            };

            const headers = {
              'Content-Type': 'application/json',
            };

            console.log(
              'Submitting form with payload:',
              { payload },
              { headers },
            );

            // try {
            //   const response = await fetch(
            //     `https://${import.meta.env.VITE_ZENDESK_SUBDOMAIN}.zendesk.com/api/v2/requests.json`,
            //     {
            //       method: 'POST',
            //       headers,
            //       body: JSON.stringify(data),
            //       auth: {
            //         username: `${import.meta.env.VITE_ZENDESK_USER_EMAIL}/token`,
            //         password: import.meta.env.VITE_ZENDESK_API_TOKEN,
            //       },
            //     }
            //   );

            //   if (response.ok) {
            //     this.showMessage = true;
            //     this.successMessage =
            //       data?.data?.inlineMessage ||
            //       'Thanks for submitting the form.';
            //     this.errorMessage = false;
            //     this.resetForm();
            //   } else {
            //     this.showMessage = true;
            //     this.successMessage = '';
            //     this.errorMessage =
            //       '<strong>We couldn’t submit your form</strong><br />Please give it another try!';
            //   }
            // } catch (error) {
            //   console.error('Error:', error);
            //   this.showMessage = true;
            //   this.successMessage = '';
            //   this.errorMessage =
            //     '<strong>We couldn’t submit your form</strong><br />Please give it another try!';
            // }
          },

          resetForm() {
            this.inputs.full_name = '';
            this.inputs.company_name = '';
            this.inputs.email = '';
            this.inputs.phone = '';
            this.inputs.message = '';
            this.errors = {};
            const formWrapper = document.getElementById('form-wrapper');

            if (formWrapper) {
              formWrapper.scrollIntoView({ behavior: 'smooth' });
            }
          },
        };
      });
    });
  },
};
